module.exports = __webpack_public_path__ + "files/e9342871ef92f577e2f9f4b99f9488f2.png";